import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <React.Fragment>
    <path d="M15.786,22.099 L15.786,20.069 C15.641,18.387 16.279,18.271 18.338,16.125 C19.962,14.559 21.325,13.254 21.325,10.818 C21.325,7.28 18.483,5.627 15.206,5.627 C14.133,5.627 13.06,5.714 12.016,6.033 L12.016,7.802 C12.886,7.541 13.814,7.367 14.742,7.367 C17.12,7.367 19.44,8.15 19.44,10.876 C19.44,14.53 14.133,16.212 14.046,18.967 L14.046,22.099 L15.786,22.099 Z M16.076,27 L16.076,24.506 L13.756,24.506 L13.756,27 L16.076,27 Z" />
  </React.Fragment>,
  'Question'
);
